import { useHistory } from "react-router-dom";
import tw from "src/utils/tw";

interface Props {
  onClick?: () => void;
  className?: string;
}

export default function CancelButton(props: Props) {
  const history = useHistory();

  function onClick() {
    if (props.onClick) {
      props.onClick();
    } else {
      history.goBack();
    }
  }

  return (
    <button
      className={tw("block text-sm text-empty", props.className)}
      type="button"
      onClick={onClick}
    >
      <i aria-hidden className="far fa-circle-xmark" /> Cancel
    </button>
  );
}
